import React, { createContext, useState, useContext } from 'react';

export const LoginContext = createContext();

export const useLoginContext = () => {
  const context = useContext(LoginContext);
  if (!context) {
    throw new Error('useLogin must be used within a loginProvider');
  }
  return context;
};

export const LoginContextProvider = ({ children }) => {
  const [nonce, setNonce] = useState(null);
  const [mobilenumber, setMobilenumber] = useState(null);

  return (
    <LoginContext.Provider value={{ nonce, setNonce, mobilenumber, setMobilenumber }}>
      {children}
    </LoginContext.Provider>
  );
};
